module.exports = __webpack_public_path__ + "static/img/product_1_4.797369c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/product_1_4.png
// module id = jFih
// module chunks = 34